import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Box, Typography } from "@curves/ui-base";
import { MemberAvatar } from '@icoach/components/infoCard/';
import InfoCard from './InfoCard';

export const CustomerInfoCard = ({ className, avatar, avatarWidth = '5.5', name, phone, sourceType, link, onClick, isShowAvatar = true, ...rest }) => {
    return (
        <InfoCard className={clsx('customer-info-card', className)} link={link} onClick={onClick} {...rest}>
            {isShowAvatar && <MemberAvatar className={'member-info-card__avatar'} src={avatar} width={avatarWidth} alt={name} />}
            <Box className={'customer-info-card__content'}>
                <Typography className={'customer-info-card__name'} title={name}>
                    {name}
                </Typography>
                {sourceType && (
                    <Typography className={'customer-info-card__source-type'} title={phone}>
                        {sourceType}
                    </Typography>
                )}
                {phone && (
                    <Typography className={'customer-info-card__phone'} title={phone}>
                        {phone}
                    </Typography>
                )}
            </Box>
        </InfoCard>
    );
};

CustomerInfoCard.prototype = {
    className: PropTypes.string,
    avatar: PropTypes.string,
    avatarWidth: PropTypes.string,
    name: PropTypes.string.isRequired,
    maskName: PropTypes.string,
    sourceType: PropTypes.string,
    phone: PropTypes.string,
    maskPhone: PropTypes.string,
    link: PropTypes.string,
    onClick: PropTypes.func,
    isShowAvatar: PropTypes.bool,
};

export default CustomerInfoCard;
